/* src/components/Users/Orders/AddonsSelection/content.tsx */
import React from 'react';

import AddonsList from './list';

interface AddonsContentProps {
  items: Array<App.CartItem>;
  offer: App.CartOffer;
  currencyCode: string;
  onAddAddon: (addon: App.Addon, item?: App.CartItem, offer?: App.CartOffer, offerPackage?: App.CartPackage) => void;
  onRemoveAddon: (addon: App.Addon) => void;
  getAddonQuantity: (addon: App.Addon) => number;
}

const AddonsContent = (props: AddonsContentProps) => {
  const { items, offer, currencyCode, onAddAddon, onRemoveAddon, getAddonQuantity } = props;
  // Sort reservations by check-in date
  items.sort((itemA, itemB) => {
    const checkInA = new Date(itemA.reservation.checkIn);
    const checkInB = new Date(itemB.reservation.checkIn);

    if (checkInA > checkInB) {
      return 1;
    }

    if (checkInA < checkInB) {
      return -1;
    }

    return 0;
  });

  // NOTE: Addons are coming from first item
  return (
    <AddonsList
      offer={offer}
      getAddonQuantity={getAddonQuantity}
      onAddAddon={onAddAddon}
      onRemoveAddon={onRemoveAddon}
      items={items}
      currencyCode={currencyCode}
    />
  );
};

export default AddonsContent;
